<template>
  <v-dialog v-model="model" :max-width="maxWidth" scrollable :fullscreen="fullscreen">
    <v-card>
      <v-card-title class="primary white--text dialog-title">
        <div class="title-content">
          <p class="headline mb-0" :style="subtitle && 'line-height: 1'">
            {{ title }}
          </p>
          <template v-if="subtitle">
            <span class="subtitle-1">
              {{ subtitle }}
            </span>
          </template>
        </div>
        <div class="title-actions">
          <slot name="title-actions"></slot>
          <circle-button icon="mdi-close" @click="model = false" />
        </div>
      </v-card-title>
      <v-card-text :class="hidePadding ? 'pa-0' : ''">
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="!hideActions">
        <v-spacer />
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
export default {
  mixins: [hasModel],
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    maxWidth: {
      type: [String, Number],
      required: false,
      default: 600,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    hidePadding: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.dialog-title {
  display: flex !important;
  align-items: center !important;
  gap: 12px;
}

.title-content {
  flex: 1;
  min-width: 0;
}

.title-content .headline {
  word-break: break-word;
  overflow-wrap: break-word;
}

.title-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Mobile responsiveness */
@media (max-width: 600px) {
  .dialog-title {
    gap: 8px;
  }

  .title-content .headline {
    font-size: 1.25rem !important;
    line-height: 1.3 !important;
  }

  .title-content .subtitle-1 {
    font-size: 0.875rem !important;
  }
}

/* Tablet responsiveness */
@media (max-width: 960px) and (min-width: 601px) {
  .title-content .headline {
    font-size: 1.375rem !important;
  }
}
</style>
